<template>
  <div>
    <v-card class="elevation-6">
      <v-card-title class="d-flex justify-space-between align-center">
        <span>{{ title }}</span>
        <div class="d-flex align-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
                @click="$refs.list && $refs.list.openEditTableDialog()"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Columnas visibles</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                fab
                color="primary"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
                @click="create"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Crear</span>
          </v-tooltip>
        </div>
      </v-card-title>

      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>

      <v-card-text>
        <orden-venta-list
          ref="list"
          @show="show"
          @edit="edit"
          @facturar-masiva="openFacturacionMasiva"
        />
      </v-card-text>
    </v-card>

    <v-dialog v-model="facturacionMasivaOpen" max-width="1400">
      <v-card>
        <v-card-title>
          Facturación masiva
          <v-spacer />
          <v-btn icon @click="facturacionMasivaOpen = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <facturacion-masiva
            v-if="facturacionMasivaOpen"
            modo="dialog"
            :initial-orden-venta-ids="facturacionMasivaOrdenIds"
            @emitido="onFacturacionMasivaEmitida"
            @finalizado="onFacturacionMasivaFinalizada"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <presupuesto-pedido-desde-productos-create
      v-if="creating"
      :open="creating"
      :items="[]"
      tipo-documento-fijo="pedido"
      :orden-venta-id="editingOrdenVentaId"
      @created="onItemCreated"
      @close="creating = false"
    />

    <orden-venta-show
      v-if="showing"
      :open="showing"
      :orden-id="selectedId"
      @close="showing = false"
      @refreshed="refetchList"
    />

    <snackbar v-model="flash" />
  </div>
</template>

<script>
import { Snackbar } from "@dracul/common-frontend";
import OrdenVentaList from "../OrdenVentaList";
import PresupuestoPedidoDesdeProductosCreate from "../../../../producto/pages/ProductoManagementPage/PresupuestoPedidoDesdeProductosCreate";
import OrdenVentaShow from "../OrdenVentaShow";
import FacturacionMasiva from "../../../../facturacion/components/FacturacionMasiva";

export default {
  name: "OrdenVentaCrud",
  components: {
    Snackbar,
    OrdenVentaList,
    PresupuestoPedidoDesdeProductosCreate,
    OrdenVentaShow,
    FacturacionMasiva,
  },
  data() {
    return {
      title: "Órdenes de venta",
      subtitle: "Órdenes de venta confirmadas, enviadas y recibidas",
      flash: null,
      creating: false,
      showing: false,
      selectedId: null,
      editingOrdenVentaId: null,
      facturacionMasivaOpen: false,
      facturacionMasivaOrdenIds: [],
    };
  },
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      this.selectedId = id;
      this.showing = true;
    }
  },
  methods: {
    create() {
      this.editingOrdenVentaId = null;
      this.creating = true;
    },
    edit(item) {
      this.editingOrdenVentaId = item.id || item._id;
      this.creating = true;
    },
    show(item) {
      this.selectedId = item.id;
      this.showing = true;
    },
    onItemCreated(wasUpdate) {
      this.creating = false;
      this.editingOrdenVentaId = null;
      this.refetchList();
      this.flash = wasUpdate ? "Orden de venta actualizada" : "Orden de venta creada";
    },
    refetchList() {
      this.$refs.list && this.$refs.list.fetch();
    },
    openFacturacionMasiva(ordenIds) {
      this.facturacionMasivaOrdenIds = ordenIds || [];
      this.facturacionMasivaOpen = true;
    },
    // La emisión ahora es asíncrona: acá el lote todavía no emitió nada.
    onFacturacionMasivaEmitida(lote) {
      this.flash = `Facturación masiva iniciada: ${lote.totalPendientes} órdenes en proceso`;
    },
    onFacturacionMasivaFinalizada(lote) {
      this.flash = `Facturación masiva: ${lote.totalEmitidas} emitidas, ${lote.totalErrores} errores`;
      this.refetchList();
    },
  },
};
</script>
